<script lang="ts" setup>
defineProps<{ tag?: string, theme?: Theme, data?: string, gradient?: boolean }>()
</script>

<template>
  <component
    :is="tag ? tag : 'p'"
    class="scrolloffset text-balance"
    :class="[`${gradient ? 'text-grad-' : ''}${theme}`, data ? '' : 'uppercase']"
  >
    <template v-if="data">
      {{ data }}
    </template>
    <slot v-else />
  </component>
</template>

<style scoped>
.scrolloffset {
  scroll-margin-top: 150px;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  @apply !leading-[0.85em];
}

h1,
h2,
h3,
h4 {
  @apply font-display font-bold;
}

h5,
h6,
p {
  @apply font-semibold;
}

h1 {
  @apply text-6xl xl:text-9xl;
}

h2 {
  @apply text-7xl xl:text-8xl;
}

h3 {
  @apply text-5xl xl:text-6xl;
}

h4 {
  @apply text-4xl xl:text-5xl;
}

h5 {
  @apply text-3xl xl:text-4xl;
}

h6 {
  @apply text-2xl xl:text-3xl;
}

p {
  @apply text-base xl:text-lg;
}

h1.light-blue,
h2.light-blue,
h3.light-blue {
  @apply text-white;
}

h1.blue,
h2.blue,
h3.blue {
  @apply text-white;
}

h1.pink,
h2.pink,
h3.pink {
  @apply text-white;
}

h4.light-blue,
h5.light-blue,
h6.light-blue {
  @apply text-yellow
}

h4.blue, h5.blue, h6.blue {
  @apply text-yellow
}

h4.pink, h5.pink, h6.pink {
  @apply text-yellow
}

h1.gradient-light-blue,
h2.gradient-light-blue,
h3.gradient-light-blue {
  @apply text-white;
}
h1.gradient-blue,
h2.gradient-blue,
h3.gradient-blue {
  @apply text-white;
}
h1.gradient-pink,
h2.gradient-pink,
h3.gradient-pink {
  @apply text-white;
}
</style>
